export default __webpack_public_path__ + "static/media/bg-effect.f25c9111.png";